import styled from 'styled-components'
import LinkBase from 'components/link'
import LightDarkImageBase from 'components/light-dark-image'
import BetaBase from 'components/beta'

export const Link = styled(LinkBase)`
    position: relative;
    display: grid;
    place-items: center;

    border: 2px solid var(--huma-color-border-default);
    border-radius: 8px;
    padding: 32px 24px;

    &:is(:hover, :focus-visible) {
        border-color: var(--huma-color-border-default-focus);
    }
`

export const LightDarkImage = styled(LightDarkImageBase)`
    img {
        display: block;

        width: 100%;
        max-width: 100px;
        max-height: 32px;
    }
`

export const Beta = styled(BetaBase)`
    position: absolute;
    top: 8px;
    right: 8px;
`